import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "2192",
  height: "1491",
  viewBox: "0 0 2192 1491",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M2191.5 1489.5L3 931L1385 1\" stroke=\"url(#paint0_linear_12_474)\" stroke-opacity=\"0.32\" stroke-width=\"2\"></path><defs><linearGradient id=\"paint0_linear_12_474\" x1=\"2113.74\" y1=\"2507.65\" x2=\"-1034.44\" y2=\"-614.429\" gradientUnits=\"userSpaceOnUse\"><stop offset=\"0.151\" stop-color=\"#001A78\" stop-opacity=\"0\"></stop><stop offset=\"0.191\" stop-color=\"#0D257C\" stop-opacity=\"0.146\"></stop><stop offset=\"1\" stop-color=\"#596294\"></stop></linearGradient></defs>", 2)
  ])))
}
export default { render: render }